import { CookieHelper } from "./CookieHelper";

export class HtmlHelpers {
    private static ENTER_KEY = '13';

    public static getUrlParameter(name: string | null) {
        const url = window.location.search.substring(1).toLowerCase();
        const params = url.split('&');
        for (const param of params) {
            const paramNameValue = param.split('=');
            if (paramNameValue[0] == name) {
                return paramNameValue[1];
            }
        }
    }

    public static enterKeyPressed(event: any) {
        const keycode = (event.keyCode ? event.keyCode : event.which);
        return keycode == HtmlHelpers.ENTER_KEY;
    }

    public static getTwoDigitStr(num: number): string {
        return (num >= 10) ? `${num}` : `0${num}`;
    }

    public static getFormattedDate(date: string | null): string {
        if (!date) return '';

        const newDate = new Date(date);
        const month = newDate.getMonth() + 1;
        const dateOfMonth = newDate.getDate();
        const year = newDate.getFullYear();
        const formattedDate = month + '/' + dateOfMonth + '/' + year;
        return formattedDate;
    }

    public static getFormattedDateYearFirst(date: string | null): string {
        if (!date) return '';

        const newDate = new Date(date);
        const month = HtmlHelpers.getTwoDigitStr(newDate.getMonth() + 1);
        const dateOfMonth = HtmlHelpers.getTwoDigitStr(newDate.getDate());
        const year = newDate.getFullYear();
        const formattedDate = year + month + dateOfMonth;
        return formattedDate;
    }

    public static getFormattedPct(value: number | null) {
        if (!value) return '';

        return value + '%';
    }

    public static getFormattedCurrency(value: number | null) {
        if (!value) return '';

        const formattedValue = (Math.round(value * 100) / 100).toString();
        return '$' + parseFloat(formattedValue).toFixed(2);
    }

    public static checkboxOnChange(name: string | null) {
        if (!name) return;

        const checked = ($('#' + name)[0] as HTMLInputElement).checked;

        checked ?
            $('div[id^=Div_' + name + ']').show() :
            $('div[id^=Div_' + name + ']').hide();

        CookieHelper.set(name, checked);
    }
}
